module.exports = __webpack_public_path__ + "static/media/time.3902ca63.svg";